import { Icon, IconProps } from '@chakra-ui/react'

export function SurveillanceIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 17" {...props}>
      <path
        d="M19.6647 9.14107L18.612 8.53005L16.5697 12.0487L17.6224 12.6597C17.9382 12.8493 18.3593 12.744 18.5277 12.4279L19.8963 10.0681C20.1068 9.73101 19.9805 9.33069 19.6647 9.14107Z"
        fill="currentColor"
      />
      <path
        d="M17.7698 6.4231L6.92685 0.10224C6.56893 -0.108455 6.12679 0.0179616 5.91625 0.376144L3.20025 5.01144C2.9897 5.36962 3.11603 5.81208 3.47395 6.02278L7.87429 8.59326L6.10573 11.1005C5.89519 11.3955 5.55832 11.5641 5.2004 11.5641H2.10543V9.64674C2.10543 8.86716 1.4738 8.21401 0.673736 8.21401H0.378977C0.168434 8.21401 0 8.38256 0 8.59326V16.6207C0 16.8314 0.168434 17 0.378977 17H0.694791C1.4738 17 2.12648 16.3679 2.12648 15.5673V13.6499H5.22146C6.27417 13.6499 7.24266 13.1443 7.85324 12.2804L9.72707 9.62567L14.3379 12.3226C14.6959 12.5333 15.138 12.4068 15.3486 12.0487L18.0646 7.3923C18.233 7.07625 18.1277 6.61272 17.7698 6.4231ZM13.9169 9.01465C13.8116 9.18321 13.6432 9.26748 13.4537 9.26748C13.3695 9.26748 13.2642 9.24641 13.18 9.20428L6.75842 5.4539C6.50577 5.30641 6.42155 4.99037 6.56893 4.73754C6.71631 4.4847 7.03212 4.40042 7.28477 4.54791L13.7274 8.29829C13.98 8.4247 14.0642 8.76182 13.9169 9.01465Z"
        fill="currentColor"
      />
      <path
        d="M13.9169 9.01465C13.8116 9.18321 13.6432 9.26748 13.4537 9.26748C13.3695 9.26748 13.2642 9.24641 13.18 9.20428L6.75842 5.4539C6.50577 5.30641 6.42155 4.99037 6.56893 4.73754C6.71631 4.4847 7.03212 4.40042 7.28477 4.54791L13.7274 8.29829C13.98 8.4247 14.0642 8.76182 13.9169 9.01465Z"
        fill="currentColor"
      />
    </Icon>
  )
}
